import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import PhoneNumbers from './PhoneNumbers';

const activeLinkStyle = {
  color: '#fff',
  backgroundColor: '#1E69B8',
  borderColor: '#1E69B8',
};

export default props => {
  const { name, content1, content2, list, link, phoneNumbers } = props.data;
  const { image1, image2 } = props;
  const phoneNumbersComponent = phoneNumbers ? (
    <div>
      <h3 className="box-header margin-top-40">Numery kontaktowe</h3>
      <div className="column-1-2">
        <PhoneNumbers phoneNumbers={phoneNumbers} />
      </div>
    </div>
  ) : (
    ' '
  );
  return (
    <div className="theme-page">
      <div className="row gray full-width page-header vertical-align-table">
        <div className="row full-width padding-top-bottom-50 vertical-align-cell">
          <div className="row">
            <div className="page-header-left">
              <h1>{name}</h1>
            </div>
            <div className="page-header-right">
              <div className="bread-crumb-container">
                <label>JESTEŚ TUTAJ:</label>
                <ul className="bread-crumb">
                  <li>
                    <Link to="/">STRONA GŁÓWNA</Link>
                  </li>
                  <li className="separator">&#47;</li>
                  <li>
                    <Link to="/uslugi">USŁUGI</Link>
                  </li>
                  <li className="separator">&#47;</li>
                  <li>{name}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix">
        <div className="row margin-top-70">
          <div className="column column-1-4">
            <ul className="vertical-menu">
              <li>
                <Link to="/uslugi/mechanika" activeStyle={activeLinkStyle} title="Mechanika">
                  MECHANIKA
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link
                  to="/uslugi/diagnostyka"
                  activeStyle={activeLinkStyle}
                  title="Diagnostyka / Kodowanie / Doposażanie pojazdu"
                >
                  DIAGNOSTYKA
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link to="/uslugi/naprawy-powypadkowe" activeStyle={activeLinkStyle} title="Naprawy powypadkowe">
                  NAPRAWY POWYPADKOWE
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link to="/uslugi/czesci-nowe-i-uzywane" activeStyle={activeLinkStyle} title="Części nowe i używane">
                  CZĘŚCI NOWE I UŻYWANE
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link to="/uslugi/motocykle" activeStyle={activeLinkStyle} title="Motocykle">
                  MOTOCYKLE
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link
                  to="/uslugi/profesjonalny-serwis-ogumienia"
                  activeStyle={activeLinkStyle}
                  title="Profesjonalny serwis ogumienia"
                >
                  SERWIS OGUMIENIA
                  <span className="template-arrow-menu" />
                </Link>
              </li>
              <li>
                <Link to="/uslugi/pomoc-drogowa" activeStyle={activeLinkStyle} title="Pomoc drogowa">
                  POMOC DROGOWA
                  <span className="template-arrow-menu" />
                </Link>
              </li>
            </ul>
            <div className="call-to-action page-margin-top">
              <div className="hexagon small">
                <div className="sl-small-car-fix" />
              </div>
              <h4 className="margin-top-58">Potrzebujesz pomocy?</h4>
              <p className="description">Umów się na wizytę w naszym serwisie.</p>
              <Link to="/kontakt" title="Kontakt" className="more">
                UMÓW SIĘ
              </Link>
            </div>
          </div>
          <div className="column column-3-4">
            <div className="row">
              <div className="column column-1-2">
                <Img
                  sizes={image1}
                  imgStyle={{ objectPosition: '0 0', maxHeight: '260px' }}
                  style={{ width: '100%', maxHeight: '260px' }}
                />
              </div>
              <div className="column column-1-2">
                <Img
                  sizes={image2}
                  imgStyle={{ objectPosition: '0 0', maxHeight: '260px' }}
                  style={{ width: '100%', maxHeight: '260px' }}
                />
              </div>
            </div>
            <div className="row page-margin-top">
              <div className="column-1-1">
                <h3 className="box-header">Opis usługi</h3>
                <p className="margin-top-20">{content1}</p>
                <p>
                  {content2}
                  {link ? (
                    <a href={link.url} className="reservation-link" target="_blank">
                      {link.title}
                    </a>
                  ) : (
                    ''
                  )}
                </p>
                <h3 className="box-header margin-top-26">Jakie usługi świadczymy?</h3>
                <ul className="list margin-top-30">
                  {list.map(item => (
                    <li key={item} className="template-bullet">
                      {item}
                    </li>
                  ))}
                </ul>
                {phoneNumbersComponent}
              </div>
            </div>
            <div className="row page-margin-top" />
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Service.js